import React, { FunctionComponent } from 'react';
import { Select as SelectBR } from '@vwfs-bronson/bronson-react';
import { useFormikContext } from 'formik';
import { t } from 'i18next';
import { FormField } from '../FormField/FormField';
import { FormFieldPropsBase } from './formfields.model';

type SelectFormFieldProps = {
  dropDownOptionsList: ReadonlyArray<{
    value: string | undefined;
    label: string;
  }>;
} & FormFieldPropsBase<HTMLSelectElement>;

export const SelectFormField: FunctionComponent<SelectFormFieldProps> = ({
  labelTranslationKey = '',
  fieldName,
  testId,
  dropDownOptionsList,
  optional = false,
  onChange,
  isDisabled,
}): React.JSX.Element => {
  const { setFieldValue, values } = useFormikContext<any>();

  const _onChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setFieldValue(fieldName, event.target.value);
    onChange?.(event);
  };

  const value = values[fieldName] ?? '';

  return (
    <FormField
      type="select"
      name={fieldName}
      testId={testId ?? fieldName}
      labelText={`${t(labelTranslationKey)}`}
      required={!optional}
      render={(fieldProps) => (
        <SelectBR
          {...fieldProps}
          disabled={isDisabled}
          aria-disabled={isDisabled}
          name={fieldName}
          value={value}
          onChange={_onChange}
        >
          {dropDownOptionsList?.map(({ label, value }) => (
            <SelectBR.Item key={`${label}`} value={`${value}`}>
              {label?.toString()}
            </SelectBR.Item>
          ))}
        </SelectBR>
      )}
    />
  );
};
